
import { Component, Prop, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { addressInfoType, contactInfoType, nameInfoType } from "@/types/Application/CommonInformation";
import { getLocationInfo } from '@/components/utils/PopulateForms/PopulateCommonInformation';
import { contactInformationDataInfoType, noticeRemoveLawyerPartyDataInfoType } from '@/types/Application/NoticeRemoveLawyerParty';

@Component({
    components:{
        UnderlineForm,
        CheckBox       
    }
})

export default class Form43Layout extends Vue {

    @Prop({required:true})
    result!: any;    
    
    @applicationState.State
    public applicantName!: nameInfoType;    

    dataReady = false;     

    existingFileNumber = '';
    acknowledgeService = false; 
    applicantLawyer = false;
    applicantFullName = '';
    lawyerName = '';
    effectiveDate = '';
    contactInfoChanged = false; 
    contactInfo = {} as contactInformationDataInfoType;
    otherParties = '';   
   
    mounted(){
        this.dataReady = false;
        this.extractInfo();       
        this.dataReady = true;        
    }
   
    public extractInfo(){        
        this.existingFileNumber = getLocationInfo(this.result.otherFormsFilingLocationSurvey);
        this.acknowledgeService = this.result.otherPartyNLPRConfirmationSurvey?.confirmation == 'Confirmed';
        this.applicantFullName = this.applicantName?Vue.filter('getFullName')(this.applicantName):'';
        this.getNoticeRemoveLawyerPartyInfo();  
    } 

    public getNoticeRemoveLawyerPartyInfo(){  
        
        this.applicantLawyer = false;
        
        this.lawyerName = '';
        this.effectiveDate = '';
        this.contactInfoChanged = false; 
        this.contactInfo = {} as contactInformationDataInfoType;
        this.otherParties = '';

        if(this.result?.noticeRemoveLawyerPartySurvey){

            let noticeRemoveLawyerParty = {} as noticeRemoveLawyerPartyDataInfoType;
            noticeRemoveLawyerParty = this.result.noticeRemoveLawyerPartySurvey;  

            this.applicantLawyer = noticeRemoveLawyerParty.ApplicantType == 'Lawyer';
            this.effectiveDate = noticeRemoveLawyerParty.EffectiveDate?Vue.filter('beautify-date')(noticeRemoveLawyerParty.EffectiveDate):'';

            if (this.applicantLawyer){

                const otherParties = [];
                for (const otherParty of noticeRemoveLawyerParty.OtherPartyInfoNlpr){
                    otherParties.push(Vue.filter('getFullName')(otherParty.name))
                }
                this.otherParties = otherParties.join(', ');

            } else {
                this.lawyerName = noticeRemoveLawyerParty?.LawyerName?noticeRemoveLawyerParty.LawyerName:'';
            }    

            this.getContactInformationResults(noticeRemoveLawyerParty);
        }             
    }

    public getContactInformationResults(noticeRemoveLawyerParty: noticeRemoveLawyerPartyDataInfoType) {    
        
        
        if (noticeRemoveLawyerParty.AddressChanges && noticeRemoveLawyerParty.AddressChanges.includes('true')){
            this.contactInfoChanged = false;
            this.contactInfo = {
                lawyerName: {} as nameInfoType,
                address: {} as addressInfoType,
                contact: {} as contactInfoType
            } 
        } else {
            this.contactInfoChanged = true;
            this.contactInfo = {
                lawyerName: noticeRemoveLawyerParty.ApplicantName?noticeRemoveLawyerParty.ApplicantName:{} as nameInfoType,
                address: noticeRemoveLawyerParty.LawyerAddressNlpr?noticeRemoveLawyerParty.LawyerAddressNlpr:{} as addressInfoType,
                contact: noticeRemoveLawyerParty.LawyerContactNlpr?noticeRemoveLawyerParty.LawyerContactNlpr:{} as contactInfoType
            } 
        }
               
    }    
 
}
